import Vue from 'vue';
import { Moment } from 'moment';
import _ from 'lodash';
import { IHeader } from '~/types/componentTypes';
import { ISearchFields } from '~/types/searchTypes';
export class SearchFields extends Vue implements ISearchFields {
    firstName = '';
    lastName = '';
    dateOfBirth: Moment | string | null = null;
    state = '';
    medicalMemberId = '';
    pharmacyMemberId = '';
    prescriber: number | null = null;
    accountNumber = '';

    getSearchObject() {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            dateOfBirth: this.dateOfBirth,
            state: this.state,
            medicalMemberId: this.medicalMemberId,
            pharmacyMemberId: this.pharmacyMemberId,
            prescriber: this.prescriber,
            accountNumber: this.accountNumber,
        };
    }

    getClassName(index: number): string {
        const groupings = this.getFieldWidths();
        if (index <= groupings.length) {
            return groupings[index];
        }

        return '';
    }

    getFieldWidths(): string[] {
        return ['col-8', 'col-4', 'col-4', 'col-5', 'col-3', 'col-4', 'col-6', 'col-12', 'col-6', 'col-6', 'col-12'];
    }

    getFieldDefaults(): ISearchFields {
        return new SearchFields();
    }

    getHeaderConfig(): IHeader[] {
        return [
            {
                value: 'FirstName',
                text: 'First Name',
            },
            {
                value: 'LastName',
                text: 'Last Name',
            },
            {
                value: 'DateOfBirth',
                text: 'Date of Birth',
            },
            {
                value: 'Address1',
                text: 'Address',
            },
            {
                value: 'City',
                text: 'City',
            },
            {
                value: 'State',
                text: 'State',
            },
            {
                value: 'ZipCode',
                text: 'ZIP Code',
            },
            {
                value: 'PrimaryPayer',
                text: 'Primary Payer',
            },
            {
                value: 'Gender',
                text: 'Gender',
            },
            {
                value: 'PhysicianName',
                text: 'Prescriber',
            },
            {
                value: 'Action',
                text: 'Action',
            },
        ];
    }
}
